import * as api from "../clients/slashid-api"
import * as errors_INTERNAL_ONLY from "../domain/errors.internal"
import { SlashIDOptions, createSlashIDConfig, checkSlashIDOptions } from "../domain/options"
import { createRetryOnNetworkErrorMiddleware } from "../utils/fetch"

export interface CreateAnonymousUserOptions {
    environment: SlashIDOptions["environment"]
    oid: string
}

export const createAnonymousUserToken = async ({ environment, oid }: CreateAnonymousUserOptions) => {
    const { baseURL } = createSlashIDConfig({ environment })

    const personsClient = new api.PersonsApi(
        new api.Configuration({
            ...api.DefaultConfig,
            basePath: baseURL,
            middleware: [
                createRetryOnNetworkErrorMiddleware({
                    maxRetries: 5,
                    baseDelayMs: 500,
                }),
            ],
        })
    )

    try {
        const { result: token } = await personsClient.postPersonsAnonymous({
            slashIDOrgID: oid,
            anonymousPersonCreateReq: {},
        })

        return token
    } catch (e: unknown) {
        if (e instanceof Error) {
            throw errors_INTERNAL_ONLY.toSlashIDError(e)
        }
        throw e
    }
}

function checkOid(options: SlashIDOptions): asserts options is SlashIDOptions & { oid: string } {
    if (typeof options.oid !== "string") {
        throw new TypeError("'oid' must be of type string")
    }
}

export const slashIDOptionsToCreateAnonymousUserOptions = (context: SlashIDOptions): CreateAnonymousUserOptions => {
    checkSlashIDOptions(context)

    const options = createSlashIDConfig(context)

    checkOid(options)

    const { baseURL, sdkURL, oid } = options
    const tokenCreateOptions: CreateAnonymousUserOptions = {
        environment: {
            baseURL,
            sdkURL,
        },
        oid,
    }

    return tokenCreateOptions
}
